import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useAuth } from 'hooks/useAuth';
import GuestOrLoginPrompt from '../GuestOrLoginPrompt';
import ProcessPurchaseForm from '../ProcessPurchaseForm';
import { StyledProcessPurchase } from './style';
import { FarmProduct } from 'public/context/CartContext';
import CartSummary from '../CartSummary/CartSummary';
import { FormInstance } from 'antd';
import CartStep from 'enums/cart-step';

interface ProcessPurchaseProps {
  farmProducts: FarmProduct[];
  setCurrent: React.Dispatch<React.SetStateAction<CartStep>>;
  current: CartStep;
  isView: boolean;
  priceTotal: number;
  isBuying?: boolean;
  form?: FormInstance;
  userForm: FormInstance;
  handleBuyProducts?: (type: string) => void;
}

const ProcessPurchase = ({
  farmProducts,
  setCurrent,
  current,
  isView,
  priceTotal,
  form,
  isBuying,
  userForm,
  handleBuyProducts,
}: ProcessPurchaseProps) => {
  const intl = useIntl();
  const { user } = useAuth();

  const [skip, setSkip] = useState<boolean>(user?.authenticated || false);

  return (
    <StyledProcessPurchase>
      {!skip && <GuestOrLoginPrompt setSkip={setSkip} />}

      {skip && (
        <>
          <div className={'form-summary-wrapper'}>
            <div className={'form-wrapper'}>
              <div className={'form-title'}>
                {intl.formatMessage({
                  id: 'process_purchase.client_information',
                })}
              </div>
              <ProcessPurchaseForm userForm={userForm} />
            </div>

            <CartSummary
              priceTotal={priceTotal}
              setCurrent={setCurrent}
              farmProducts={farmProducts}
              userForm={userForm}
              current={current}
              isView={isView}
              form={form}
              isBuying={isBuying}
              upperHandleBuyProducts={handleBuyProducts}
            />
          </div>
        </>
      )}
    </StyledProcessPurchase>
  );
};

export default ProcessPurchase;
